import Checkbox from "@material-ui/core/Checkbox";
import React, { Component } from "react";
import countTournamentStats from "../../util/CountTournamentStats";

class CloseTournamentContainer extends Component {
  state = {
    tournamentStatus: {},
  };

  handleCloseToggle = async (e) => {
    let checked = e.target.checked;

    // Update tournamentStatus document
    await window.firebase
      .firestore()
      .collection("tournamentStatus")
      .doc(this.props.tournament.id)
      .update({
        closed: checked,
        closeTimestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        inPSDInvoice: !this.state.tournamentStatus.inPSDInvoice
          ? checked
          : true,
      });

    // If closing the tournament, count all statistics and update tournament document
    if (checked) {
      try {
        const stats = await countTournamentStats(
          this.props.tournament.id,
          window.firebase.firestore.FieldValue.serverTimestamp()
        );
        console.log(
          `📊 Tournament ${this.props.tournament.id} statistics:`,
          stats
        );
      } catch (error) {
        console.error("Error in handleCloseToggle:", error);
      }
    }
  };

  handlePSDToggle = (e) => {
    let checked = e.target.checked;
    window.firebase
      .firestore()
      .collection("tournamentStatus")
      .doc(this.props.tournament.id)
      .update({
        inPSDInvoice: checked,
      });
  };

  UNSAFE_componentWillMount = () => {
    if (!this.props.psdPage) {
      window.firebase
        .firestore()
        .collection("tournamentStatus")
        .doc(this.props.tournament.id)
        .onSnapshot((doc) => {
          let tournamentStatus = doc.data();
          this.setState({ tournamentStatus: tournamentStatus || {} });
        });
    }
  };

  render() {
    return (
      <Checkbox
        checked={
          this.props.psdPage
            ? this.props.tournamentStatus.inPSDInvoice || false
            : this.state.tournamentStatus.closed || false
        }
        onClick={
          this.props.psdPage ? this.handlePSDToggle : this.handleCloseToggle
        }
        disabled={this.props.psdPage && !this.props.isTournifyAdmin}
      />
    );
  }
}

export default CloseTournamentContainer;
